<template>
	<div class="popup popup--middle" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Заявка на сотрудничество</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__description">Регистрация и все торги для поставщиков бесплатны! Присоединяйтесь к компании <br> успешных партнеров и заключайте выгодные контракты</div>
			<hr>
			<div class="popup__content">
				<div class="info-list">
					<div class="info-list__item">
						<div class="info-list__title page-subtitle">Контактное лицо</div>
						<div class="info-item">
							<div class="info-item__el">
								<InputText label="Имя *" placeholder="Введите имя" v-model="formData.name" :errors="v$.formData.name.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="Фамилия *" placeholder="Введите фамилию"  v-model="formData.lastName" :errors="v$.formData.lastName.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="Отчество *" placeholder="Введите отчество"  v-model="formData.secondName" :errors="v$.formData.secondName.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="E-mail *" placeholder="Введите E-mail" v-model="formData.email" :errors="v$.formData.email.$errors"/>
							</div>
							<div class="info-item__el info-item__el--2">
								<input-select label="Город *" :errors="v$.formData.city.$errors">
									<template #select>
										<Multiselect
											:can-clear="true"
											:canDeselect="false"
											:searchable="true"
											placeholder="Выберите город"
											no-results-text="Город не найден"
											ref="multiselect"
											:label="'name'"
											:value-prop="'name'"
											v-model="formData.city"
											:filter-results="false"
											:min-chars="2"
											:resolve-on-load="true"
											:delay="2000"		
											:no-options-text="'Города не найдены'"
											:noOptionsText="'Введите название города'"
											:options="async function(query) {
												return await fetchCities(query)
											}"/>
									</template>
								</input-select>
							</div>
							<div class="info-item__el info-item__el--3">
								<InputMultiplyPhone v-model="formData.phones"/>
							</div>
						</div>
					</div>
					<div class="info-list__item">
						<div class="info-list__title page-subtitle">Организация</div>
						<div class="info-item">
							<div class="info-item__el">
								<input-select :label="'Тип регистрации*'" :errors="v$.formData.legalForm.$errors">
									<template #select>
										<Multiselect
											:can-clear="false"
											:canDeselect="false"
											:placeholder="'Выберите тип'"
											ref="multiselect"
											:label="'name'"
											:value-prop="'id'"
											:options="legal"
											v-model="formData.legalForm"
											/>
									</template>
								</input-select>
							</div>
							<div class="info-item__el info-item__el--2">
								<InputText label="Наименование организации *" placeholder="Введите наименование организации" v-model="formData.companyName" :errors="v$.formData.companyName.$errors"/>
							</div>							
							<div class="info-item__el">
								<InputText label="ИНН(Иной налоговый идентификатор для импорта) *" :placeholder="'Введите ИНН'" :number="30" v-model="formData.inn" :errors="v$.formData.inn.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="ОГРН *" placeholder="Введите ОГРН" :number="15" v-model="formData.ogrn" :errors="v$.formData.ogrn.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="КПП *" placeholder="Введите КПП" :number="9" v-model="formData.kpp" :errors="v$.formData.kpp.$errors"/>
							</div>	
							<div class="info-item__el ">
								<InputText label="Факс" placeholder="Введите Факс" v-model="formData.fax"/>
							</div>						
							<div class="info-item__el info-item__el--2">
								<InputText label="Название головного офиса" placeholder="Введите название головного офиса" v-model="formData.mainOfficeName"/>
							</div>					

							<div class="info-item__el info-item__el--3">
								<InputText label="Юридический адрес *" placeholder="Введите юридический адрес" v-model="formData.legalAddress" :errors="v$.formData.legalAddress.$errors"/>
							</div>							
							<div class="info-item__el info-item__el--3">
								<div class="line-btn">
									<InputText label="Фактический адрес *"  placeholder="Введите фактический адрес" v-model="formData.actualAddress" :errors="v$.formData.actualAddress.$errors"/>
									<button v-if="formData.legalAddress && formData.actualAddress !== formData.legalAddress" class="btn btn--color" @click="formData.actualAddress = formData.legalAddress">Совпадает с юридическим</button>
								</div>
							</div>
							<div class="info-item__el">
								<InputChoice label="Работает с НДС" v-model="formData.workWithVat" />
							</div>
							<div class="info-item__el">
								<InputChoice label="Производитель" v-model="formData.isManufacturer" />
							</div>
							<div class="info-item__el">
								<InputChoice label="Работает по EDI" v-model="formData.workWithEdi" />
							</div>
							<div class="info-item__el">
								<input-select label="Продукция подконтрольна *" :errors="v$.formData.productControl.$errors">
									<template #select>
										<Multiselect
											v-model="formData.productControl"
											:can-clear="false"
											:canDeselect="false"
											:placeholder="'Выберите организацию'"
											ref="multiselect"
											:label="'name'"
											:value-prop="'id'"
											:mode="'tags'"
											:options="productControl"
											/>
									</template>
								</input-select>
							</div>
							<template v-if="formData.workWithEdi">
								<div class="info-item__el">
									<input-select :label="'EDI *'" :errors="v$.formData.edi.$errors">
										<template #select>
											<Multiselect
												v-model="formData.edi"
												:can-clear="false"
												:canDeselect="false"
												:placeholder="'Выберите EDI'"
												ref="multiselect"
												:label="'name'"
												:value-prop="'id'"
												:options="edi"
												/>
										</template>
									</input-select>
								</div>
							</template>
						</div>
					</div>
				</div>
				<hr>
				<ProductCategories v-model="formData.productGroups" :authorized="false"/>
				<hr>
				<div class="info-textarea">
					<div class="page-subtitle">Расскажите о себе</div>
					<InputTextarea :placeholder="'Дополнительная информация'" v-model="formData.extraInfo"/>
				</div>
				<hr>
				<div class="info-docs">
					<div class="page-subtitle">Документы</div>
					<UploadDocs v-model="formData.documents" />
				</div>
			</div>
			<hr>
		<div class="form__submit">
			<button class="form__submit-btn btn btn--color" @click.prevent="checkReCaptcha">Отправить заявку</button>
			<div class="form__submit-description">Нажимая кнопку «Отправить», Вы даете согласие на обработку <a target="_blank" :href="staticData.personalLink">персональных данных</a></div>
		</div>
		</div>
	</div>
</template>

<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputMultiplyPhone from "@/components/base/utils/formElements/InputMultiplyPhone.vue";
import InputChoice from "@/components/base/utils/formElements/InputChoice.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";
import UploadDocs from "@/components/base/utils/UploadDocs.vue";
import objectToFormData from "@/utils/ObjectToFormData";
import staticData from '@/enums/staticData';
import Fetch from "@/utils/Fetch";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, minLength, maxLength} from '@vuelidate/validators'
import {useToast} from "vue-toastification";
const {withMessage} = helpers

const checkLength  = (min,max) => (value) => {
	if(value.length === min || value.length === max){
		return true
	}
	return false
}


export default {
	name: "CollaborationFeebackPopup",
	components: {InputText, InputChoice ,Multiselect, InputSelect,ProductCategories,InputTextarea,UploadDocs, InputMultiplyPhone},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	props: {
		legal: {
			type: Array,
			default: () => []
		},
		edi: {
			type: Array,
			default: () => []
		},
		productControl: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				name: '',
				lastName: '',
				secondName: '',
				email: '',
				phones: '',
				city: '',
				legalForm: '',
				workWithEdi: false,
				isManufacturer: true,
				workWithVat: true,
				productControl: [],
				mainOfficeName: '',
				edi: '',
				fax: '',
				inn: '',
				ogrn: '',
				kpp: '',
				companyName: '',
				legalAddress: '',
				actualAddress: '',
				extraInfo: '',
				productGroups: [],
				documents: []
			}
		}
	},
	methods: {
		changeLegal(value) {
			this.formData.legalForm = value
		},
		async checkReCaptcha(e) {
			e.preventDefault();
			const validated = await this.v$.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			// eslint-disable-next-line no-undef
			grecaptcha.ready(() => {
				// eslint-disable-next-line no-undef
				grecaptcha.execute('6Le-0jsmAAAAANJNzqizBZv0AZCkt7xN3OkDdRCR', {action: 'submit'}).then(async (token) => {
					await this.sendForm(token)
				});
			});
		},
		async sendForm(token) {
			const validated = await this.v$.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			const body = objectToFormData({
				name: this.formData.name,
				lastName: this.formData.lastName,
				secondName: this.formData.secondName,
				email: this.formData.email,
				phones: this.formData.phones,
				city: this.formData.city,
				legalForm: this.formData.legalForm,
				workWithEdi: this.formData.workWithEdi,
				isManufacturer: this.formData.isManufacturer,
				workWithVat: this.formData.workWithVat,
				productControl: this.formData.productControl,
				mainOfficeName: this.formData.mainOfficeName,
				edi: this.formData.edi,
				fax: this.formData.fax,
				inn: this.formData.inn,
				ogrn: this.formData.ogrn,
				kpp: this.formData.kpp,
				companyName: this.formData.companyName,
				legalAddress: this.formData.legalAddress,
				actualAddress: this.formData.actualAddress,
				extraInfo: this.formData.extraInfo,
				productGroups: this.formData.productGroups,
				documents: this.formData.documents,
				token
			})

			let response = await Fetch('suppliers/add/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Заявка на сотрудничество успешно зарегистрирована');
				this.$emit('close')
			} else {
				this.toast.error(response.message);
			}
		},
		async fetchCities(query) {
			if(!query) return 
			const response = await Fetch(`info/cities/search/?query=${query}`, {
				method: 'GET',
			});
			return response.data
		}
	},
	computed: {
		staticData() {
			return staticData
		}
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните имя", required),
					minLength: withMessage("В имени должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В имени должно быть максимум 30 букв", maxLength(30)),
				},
				lastName: {
					required: withMessage("Заполните фамилию", required),
					minLength: withMessage("В фамилии должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В фамилии должно быть максимум 30 букв", maxLength(30)),
				},
				secondName: {
					required: withMessage("Заполните отчество", required),
					minLength: withMessage("В отчестве должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В отчестве должно быть максимум 30 букв", maxLength(30)),
				},
				email: {
					required: withMessage('Заполните E-mail', required),
					email: withMessage('Неверный формат электронной почты', email),
				},
				city: {
					required: withMessage("Выберите город", required),
				},
				legalForm: {
					required: withMessage("Выберите тип", required),
				},
				inn: {
					required: withMessage("Заполните ИНН", required),
				},
				ogrn: {
					checkLength: withMessage('В ОГРН должно быть 13 или 15 цифр', checkLength(13,15))
				},
				edi: {
					required: this.formData.workWithEdi ? withMessage("Заполните EDI", required) : true,
				},
				productControl: {
					required: withMessage("Заполните кому подконтрольна", required),
				},
				companyName: {
					required: withMessage("Заполните наименование организации", required),
					minLength: withMessage("В наименовании должно быть минимум 3 букв", minLength(3)),
				},
				legalAddress: {
					required: withMessage("Заполните адрес", required),
					minLength: withMessage("В адресе должно быть минимум 5 букв", minLength(5)),
				},
				actualAddress: {
					required: withMessage("Заполните адрес", required),
					minLength: withMessage("В адресе должно быть минимум 5 букв", minLength(5)),
				},
				kpp: {
					checkLength: withMessage('В кпп должно быть 9 цифр', checkLength(9,9))				
				}
			}
		}
	},

}
</script>
